<div class="modal-overlay"></div>
<div class="modal-container" role="dialog" aria-modal="true">
  <button class="closeBtn" (click)="close()">
    <app-icon icon="close" class="large-icon"></app-icon>
  </button>
  <div class="content f-col">
    <div class="title-and-desc f-col">
      <div class="large-bold-text">Impersonate a User</div>
      <div class="input-wrapper">
        <label for="impersonateLabel" id="impersonateLabel">Enter an email to impersonate:</label>
        <div class="f-row search">
          <input id="impersonateInput" class="custom-input" matInput
            maxlength="40" aria-labelledby="impersonateLabel" #impersonateInput
            (keyup.enter)="impersonate(impersonateInput.value)">
            <button class="custom-button-large-primary"
                  (click)="impersonate(impersonateInput.value)"
                  [disabled]="isDisabled(impersonateInput.value)">
              <app-icon icon="impersonate-eye" class="impersonate-icon"/>
            </button>
          </div>
        </div>
      </div>

      @if (impersonationHistory.length > 0) {
        <div class="history-section">
          <div class="history-header f-row justify-content-between align-center">
            <div class="small-bold-text">Recent Impersonations</div>
            <button class="clear-history-btn" (click)="clearHistory()">
              Clear
            </button>
          </div>

          <ul class="history-list">
            @for (user of impersonationHistory; track user.username) {
              <li class="history-item" (click)="impersonateFromHistory(user)">
                <div class="user-name">{{ user.displayName }}</div>
                <div class="user-username">{{ user.username }}</div>
              </li>
            }
          </ul>
        </div>
      }

      <button class="custom-button-large-secondary" (click)="close()">Cancel</button>
    </div>
    @if (isLoadingUserData$ | async) {
      <app-spinner></app-spinner>
    }
  </div>
